// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ca3af012f50ee92544f5","655":"69b04cc6e4c6cb201993"}[chunkId] + ".js";
};